/*=========================================================================================
  File Name: moduleGroupMutations.js
  Description: Group Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_GROUP(state, group) {
		state.groups.unshift(group);
	},
	SET_GROUPS(state, groups) {
		state.groups = groups;
	},
	SET_SELECTED_GROUP(state, group) {
		state.selectedGroup = group;
	},
	UPDATE_GROUP(state, group) {
		const groupIndex = state.groups.findIndex((p) => p.id === group.id);
		Object.assign(state.groups[groupIndex], group);
	},
	REMOVE_GROUP(state, itemId) {
		const ItemIndex = state.groups.findIndex((p) => p.id === itemId);
		state.groups.splice(ItemIndex, 1);
	},
	SET_GROUPS_ACTIVITY(state, groups) {
		state.groupsActivity = groups;
	},
	ADD_GROUP_ACTIVITY(state, groups) {
		let arrayNew = [];
		Array.isArray(groups)
			? (arrayNew = state.groupsActivity.concat(
					groups.filter((element) => state.groupsActivity.find((e) => e.id === element.id) === undefined)
			  ))
			: (arrayNew = state.groupsActivity.concat(groups));

		state.groupsActivity = arrayNew;
	},
	REMOVE_GROUP_ACTIVITY(state, itemId) {
		const ItemIndex = state.groupsActivity.findIndex((p) => p.id === itemId);
		state.groupsActivity.splice(ItemIndex, 1);
	},
	CLEAN_GROUP_ACTIVITY(state) {
		state.groupsActivity = [];
	},
};
